import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchUsers } from "thunks";
import { initUsersSettings, setSelectedUsers } from "actions";
import UserFetching from "./UserFetching";
import NotFoundV2 from "../NotFound/NotFoundV2";
import User from "./User";

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
      requestsTokens: []
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(initUsersSettings());
    dispatch(fetchUsers());
  }

  componentDidUpdate(prevProps, prevState) {
    const { role, searchWord, dispatch } = this.props;
    if (prevProps.role !== role || prevProps.searchWord !== searchWord) {
      this.setState({
        currentPage: 0
      });
      dispatch(fetchUsers());
    }
  }

  handleSelectedUsers = user => {
    const { selectedUsers, dispatch } = this.props;
    if (selectedUsers.some(({ id }) => id === user.id)) {
      dispatch(
        setSelectedUsers(selectedUsers.filter(({ id }) => id !== user.id))
      );
    } else {
      dispatch(setSelectedUsers([...selectedUsers, user]));
    }
  };

  render() {
    const { fetching, users, error, selectedUsers } = this.props;

    if (fetching) {
      return <UserFetching />;
    }

    if (error != null && error.code === 404) {
      return <NotFoundV2 />;
    }

    if (users === undefined || users.length === 0) {
      return null;
    }

    return (
      <div className="small-11 row">
        {users.map(user => (
          <User
            user={user}
            key={`user-${user.id}`}
            selectedUsers={selectedUsers}
            handleSelectedUsers={this.handleSelectedUsers}
          />
        ))}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.authorizations.fetching,
  fetched: state.authorizations.fetched,
  selectedUsers: state.authorizationsSettings.selectedUsers,
  users: state.authorizations.items,
  error: state.authorizations.error,
  searchWord: state.authorizationsSettings.filter.searchWord,
  role: state.authorizationsSettings.filter.role
});

export default connect(mapStateToProps)(Users);



// WEBPACK FOOTER //
// ./src/components/Authorizations/Users.js